export default {
  custom_allergen: {
    placeholder: 'Aangepaste optie toevoegen',
  },
  buttons: {
    add: 'Toevoegen',
  },
};
